import MyCalendar from './MyCalendar'

export default MyCalendar
